import { useState } from "react";
import useRegistration from "../hooks/useRegistration";
import { toast } from 'react-toastify';

const initialState = {
  firstName: "",
  lastName: "",
  email: "",
  gender: "",
  address: "",
  course: "",
};

const RegistrationForm = () => {


  const [state, setState] = useState(initialState);

  const { addRegistartion, isRegistering } = useRegistration();


  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };


  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const response = await addRegistartion(state);
      clearState();


      return toast.success(response?.data?.message || "Success")

    } catch (error) {
      console.error("Error while Registration:", error);
      toast.error(error?.response?.data?.message || error?.response?.data?.error || "Something went wrong")
    }
  }
  // const container = {
  //   display: "flex",
  //   width: "100%",
  //   minHeight: "100vh",
  //   backgroundColor: "#2f2a2a",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   padding: "20px",
  //   boxSizing: "border-box",
  // };

  return (
    <div id="form" className="text-center student-registration-section">
      <div className="container">
        <div className="section-title">
          <h2>Registration</h2>
        </div>
        <div className="registration-form-box">
          <div className="registration-form-image">
            <img
              src="https://images.pexels.com/photos/3184300/pexels-photo-3184300.jpeg"
              alt="students"
            />
          </div>
          <div className="registration-form-fields">
            <h3 className="registration-form-heading">STUDENT REGISTRATION FORM</h3>
            <form onSubmit={handleSubmit} className="registration-form">
              <div className="registration-input-row">
                <input type="text" placeholder="First name" className="registration-input" id="firstName" name="firstName" required onChange={handleChange} value={state.firstName} />
                <input type="text" placeholder="Last name" className="registration-input" id="lastName" name="lastName" required onChange={handleChange} value={state.lastName} />
              </div>
              <input type="email" placeholder="Email" className="registration-input-full" id="email" name="email" required onChange={handleChange} value={state.email} />

              <div className="registration-gender-row">
                <label><b>Gender:</b></label>
                <label><input type="radio" name="gender" id="gender" onChange={handleChange} value="female" required checked={state.gender === "female"} /> Female</label>
                <label><input type="radio" name="gender" id="gender" onChange={handleChange} value="male" checked={state.gender === "male"} /> Male</label>
                <label><input type="radio" name="gender" id="gender" onChange={handleChange} value="other" checked={state.gender === "other"} /> Other</label>
              </div>
              <input type="text" placeholder="Address" className="registration-input-full" id="address" name="address" required onChange={handleChange} value={state.address} />
              <input type="text" placeholder="Course" className="registration-input-full" id="course" name="course" required onChange={handleChange} value={state.course} />

              <div className="registration-button-row">
                <button type="reset" className="registration-btn registration-btn-reset">RESET ALL</button>
                <button type="submit" className="registration-btn registration-btn-submit" disabled={isRegistering}>SUBMIT FORM</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
